import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import HistoryIcon from '@mui/icons-material/History';
import TuneIcon from '@mui/icons-material/Tune';

const tabs = [
  { label: 'Users', path: '/admin/users', icon: <PeopleIcon /> },
  { label: 'Audit Log', path: '/admin/audit-log', icon: <HistoryIcon /> },
  { label: 'Settings', path: '/admin/settings', icon: <TuneIcon /> },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const currentTab = tabs.findIndex((t) => location.pathname.startsWith(t.path));

  return (
    <Box>
      <Typography variant="h4" sx={{ fontWeight: 600, mb: 3 }}>
        Administration
      </Typography>

      <Tabs
        value={currentTab === -1 ? 0 : currentTab}
        onChange={(_, idx) => navigate(tabs[idx].path)}
        sx={{ mb: 4, borderBottom: 1, borderColor: 'divider' }}
      >
        {tabs.map((tab) => (
          <Tab key={tab.path} icon={tab.icon} iconPosition="start" label={tab.label} />
        ))}
      </Tabs>

      <Outlet />
    </Box>
  );
}
